/* 
    [상품 데이터]
    1. 상품번호
    2. 상품명
    3. 공급가(물품 대금)
    4. 판매가(매출 계산)
    5. 상품이미지
*/

import product1 from 'routes/adminMobile/images/product_1.png';
import product2 from 'routes/adminMobile/images/product_2.png';
import product3 from 'routes/adminMobile/images/product_3.png';

const testProductData = [
    {
        productNo : 1,
        productName : "딸기먹구싶오",
        productSupplyPrice : 3000,
        productSalesPrice : 20000,
        productImg : product1,
    },
    {
        productNo : 2,
        productName : "오렌지먹구싶오",
        productSupplyPrice : 4000,
        productSalesPrice : 30000,
        productImg : product2,
    },
    {
        productNo : 3,
        productName : "파인애플먹구싶오",
        productSupplyPrice : 5000,
        productSalesPrice : 40000,
        productImg : product3,
    },
];

export default testProductData;